import * as React from "react";

export default () => {
  return <div>Övriga kommentarer och information kring besiktningen</div>;
};
